import NumberRow from "./NumberRow";
import SelectRow from "./SelectRow";
import TranslatedTextRow from "./TranslatedTextRow";
import TextRow from "./TextRow";
import DictsListRow from "./DictsListRow";
import DateRange from "./DateRange";

const componentTypes = {
  number: NumberRow,
  select: SelectRow,
  multiselect: SelectRow,
  dicts_list: DictsListRow,
  date_range: DateRange
};

export function getFieldComponent(attribute) {
  if (attribute.type === "text") {
    if (attribute.translate) {
      return TranslatedTextRow;
    } else {
      return TextRow;
    }
  }
  return componentTypes[attribute.type];
}
